import React, { FC } from "react";

import { Button } from "@epignosis_llc/gnosis";

import { useApplyTranslations } from "@hooks";

type SignInFooterProps = {
  isSandbox: boolean;
  showOnModal: boolean;
  noUserImpersonated: boolean;
  signInLoading: boolean;
  onRedirectToMainPortal: () => void;
  onUserLogOut: () => void;
};

const SignInFooter: FC<SignInFooterProps> = ({
  isSandbox,
  showOnModal,
  noUserImpersonated,
  signInLoading,
  onRedirectToMainPortal,
  onUserLogOut,
}) => {
  const { t } = useApplyTranslations();

  if (showOnModal) {
    return (
      <section className="footer-container">
        <div className="btns-wrapper">
          {isSandbox ? (
            <Button color="primary" type="button" onClick={onRedirectToMainPortal}>
              {t("sandbox.sandboxModeAction")}
            </Button>
          ) : (
            <>
              <Button color="secondary" type="button" onClick={onUserLogOut}>
                {t("general.logOut")}
              </Button>
              {!noUserImpersonated && (
                <Button className="login-btn" type="submit" isLoading={signInLoading}>
                  {t("signIn.login")}
                </Button>
              )}
            </>
          )}
        </div>
      </section>
    );
  }

  return (
    <Button type="submit" block isLoading={signInLoading} className="sign-in-btn">
      {t("signIn.login")}
    </Button>
  );
};

export default SignInFooter;
